import { useNavigate } from 'react-router-dom';
import { EllipsisVertical, Pencil } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';
import { convertToDateFormat } from '@/helpers/dateHelpers';

import { COACH_ACTIVITY_STATUS } from '@/app/coachActivity/enums';

const CoachRow = ({ coach }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/coach/${coach.id}`);
  };

  const hasPendingActivity = coach.coachActivities.some(
    (coachActivity) =>
      coachActivity.status === COACH_ACTIVITY_STATUS.SUBMITTED &&
      coachActivity.isAgreedToTerms
  );

  return (
    <>
      <TableRow onClick={handleRowClick} className="cursor-pointer">
        <TableCell className="py-2">
          {coach.user.firstname} {coach.user.lastname}
        </TableCell>
        <TableCell className="py-2">{coach.user.email}</TableCell>
        <TableCell className="py-2">
          {coach.coachActivities
            .map((activity) => activity.activity.title)
            .join(', ')}
        </TableCell>
        <TableCell className="py-2">
          {convertToDateFormat(coach.createdAt)}
        </TableCell>
        <TableCell className="py-2">
          {hasPendingActivity && (
            <Badge variant="destructive">Approval Needed</Badge>
          )}
        </TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
              <DropdownMenuLabel>{coach.name}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <Pencil />
                Edit Coach
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CoachRow;
